import {
  PRODUCT_URL,
  PRODUCT_APP_ID,
  PRODUCT_APP_SECRET,
  authToken
} from '../env'
import axios from '../_client'
import { EventBus } from '@/event-bus'

const databaseSelectionAxiosInstaceV1 = axios.create({
  baseURL: `${PRODUCT_URL}/api/v1`,
  headers: {
    'app-id': PRODUCT_APP_ID,
    'app-secret': PRODUCT_APP_SECRET
  }
})

databaseSelectionAxiosInstaceV1.interceptors.response.use(
  function(response) {
    if (response.data.redirect_to) {
      location.href = response.data.redirect_to
    }
    return response
  },
  function(error) {
    if (error.response.status === 401 || error.response.status === 403) {
      EventBus.$emit('unauthorized')
    }
    if (error.response.status !== 404) {
      EventBus.$emit('show-error-modal', error)
    }
    return Promise.reject(error)
  }
)

export const DatabaseSelectionAPI = {
  /**
   * Fetch data
   */
  fetch(locationId) {
    return databaseSelectionAxiosInstaceV1({
      method: 'get',
      url: `/locationProducts/syncSetting/${locationId}`,
      headers: {
        'auth-token': authToken()
      }
    })
  },
  /**
   * Fetch data
   */
  create(collection) {
    return databaseSelectionAxiosInstaceV1({
      method: 'post',
      url: `/locationProducts/syncSetting`,
      data: collection,
      headers: {
        'auth-token': authToken()
      }
    })
  },

  /**
   * Insert data
   */
  update(collection) {
    return databaseSelectionAxiosInstaceV1({
      method: 'post',
      url: `/locationProducts/syncSetting/${collection.id}`,
      data: collection,
      headers: {
        'auth-token': authToken()
      }
    })
  },

  /**
   * Insert data to import POS
   */
  updateImport(collection) {
    return databaseSelectionAxiosInstaceV1({
      method: 'post',
      url: `/locationPosProduct/import`,
      params: {
        use_master_products: 1
      },
      data: collection,
      headers: {
        'auth-token': authToken()
      }
    })
  },

  /**
   * Insert data to import COVA
   */
  updateImportCova(collection) {
    return databaseSelectionAxiosInstaceV1({
      method: 'post',
      url: `/locationPosProduct/syncImages`,
      data: {
        location_id: collection.location_id,
        images: collection.image
      },
      headers: {
        'auth-token': authToken()
      }
    })
  },

  /**
   * Partial Sync
   */
  partialSync(data) {
    return databaseSelectionAxiosInstaceV1({
      method: 'post',
      url: `/locationPosProduct/syncPosProducts`,
      data: data,
      headers: {
        'auth-token': authToken()
      }
    })
  }
}
